import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import BrandCard from "../brand-card";
import CommonLabel from "../label";
import useEmblaCarousel from "embla-carousel-react";
import { useCallback } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
const BrandCarousel = ({ brands, label }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
    dragFree: false,
    slidesToScroll: 1,
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <Box
      sx={{
        width: "100%",
        // px: { xs: 1.5, sm: 2, md: 3 },
        py: { xs: 2, sm: 2.5, md: 3 },
        bgcolor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: { xs: 2, sm: 2 },
          gap: 2,
        }}
      >
        <CommonLabel
          sx={{
            fontSize: { xs: "18px", sm: "22px" },
            fontWeight: 700,
            color: "#111",
            textTransform: "uppercase",
            lineHeight: 1.2,
          }}
        >
          {label}
        </CommonLabel>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            onClick={scrollPrev}
            aria-label="Previous Brands"
            sx={{
              width: { xs: 32, sm: 36 },
              height: { xs: 32, sm: 36 },
              bgcolor: "#f3f3f3",
              "&:hover": { bgcolor: "#e8e8e8" },
            }}
          >
            <ChevronLeftIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>

          <IconButton
            onClick={scrollNext}
            aria-label="Next Brands"
            sx={{
              width: { xs: 32, sm: 36 },
              height: { xs: 32, sm: 36 },
              bgcolor: "#f3f3f3",
              "&:hover": { bgcolor: "#e8e8e8" },
            }}
          >
            <ChevronRightIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ overflow: "hidden" }} ref={emblaRef}>
        <Box sx={{ display: "flex" }}>
          {brands.map((brand) => (
            <Box
              key={brand?.brand_id}
              sx={{
                flex: "0 0 auto",
                minWidth: 0,
                pr: { xs: 1.25, sm: 2 },
                width: {
                  xs: "50%",
                  sm: "33.3333%",
                  md: "25%",
                  lg: "16.6667%",
                },
              }}
            >
              <BrandCard
                cardImage={brand?.brand_image}
                cardText={brand?.brand_name}
                cardUrl={`brand/${brand?.brand_name}`}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BrandCarousel;
